// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_TOPIC_EDIT = "Uprav popis a fotku";
export const SEO_TITLE_FORUM_TOPIC_INFO_category = "O kategorii %(category)s";
export const SEO_TITLE_FORUM_TOPICS = "Diskuze o v\u0161em, co \u017eivot p\u0159in\u00e1\u0161\u00ed";
